import { useState } from 'react';

const useModal = (props) => {
  const [isShowing, setIsShowing] = useState(props.state);
  console.log(props.state);
  function toggle(item) {
    setIsShowing(!isShowing);
   
  }

  return {
    isShowing,
    toggle,
    
  }
};

export default useModal;